import { EventEmitter } from "@angular/core";
import { CHDevice, CHService } from "@app/project/model";
import { LoadingState } from "../../../root-store/api-result.state";
import { CHServiceActions } from "../actions";
import { CHLiteServiceState, CHServiceState } from "../clarehome.state";

interface ServiceMap {
    uuid: string;
    device: CHDevice;
    service: CHService;
    callbackEmitter?: EventEmitter<any>;
}

const removePendingDeletionByDevice = (pendingDeletions, actionDeviceUid) => {
    if (pendingDeletions) {
        pendingDeletions.forEach((item, index) => {
            if (item.device && item.device.UID === actionDeviceUid) {
                pendingDeletions.splice(index, 1);
            }
        });
    }
};

const removePendingDeletion = (pendingDeletions, services) => {
    if (pendingDeletions) {
        pendingDeletions.forEach((item, index) => {
            if (!Object.keys(services).includes(item.service.instanceId)) {
                pendingDeletions.splice(index, 1);
            }
        });
    }
};

const addPendingDeletion = (pendingDeletions: ServiceMap[], serviceMap: ServiceMap) => {
    const serviceMapCopy = { ...serviceMap };
    delete serviceMapCopy.callbackEmitter;
    const pendingDeletionsCopy = [...pendingDeletions];
    if (!pendingDeletions.some(item => item?.service?.instanceId === serviceMapCopy.service.instanceId)) {
        pendingDeletionsCopy.push(serviceMapCopy);
    }
    return pendingDeletionsCopy;
};

export const chServicereducer = (
    state: CHServiceState = { uuid: null, result: null, callState: LoadingState.init },
    action: CHServiceActions.Actions = null
): CHServiceState => {
    switch (action.type) {
        case CHServiceActions.ActionTypes.ClearServiceState: {
            return {
                ...state,
                result: null,
                uuid: null,
                callState: LoadingState.init,
            };
        }

        case CHServiceActions.ActionTypes.DeleteServiceMap: {
            let pendingDeletions = state?.pendingDeletions || [];
            pendingDeletions = addPendingDeletion(pendingDeletions, action.payload);
            return {
                ...state,
                pendingDeletions,
            };
        }

        case CHServiceActions.ActionTypes.RemovePendingServiceMapDeletion: {
            const actionDeviceUid = action.payload.data?.UID || action.payload.securityZone?.uid;
            const pendingDeletions = state.pendingDeletions;
            removePendingDeletionByDevice(pendingDeletions, actionDeviceUid);

            return {
                ...state,
                pendingDeletions,
            };
        }

        case CHServiceActions.ActionTypes.DeleteServiceConfirmationDismiss: {
            return {
                ...state,
                pendingDeletions: [],
            };
        }

        case CHServiceActions.ActionTypes.DeleteServiceSuccess: {
            const services = state.result;
            delete services[action.result.result.instanceId];
            return {
                ...state,
                result: services,
                uuid: action.result.uuid,
                callState: LoadingState.loaded,
            };
        }

        case CHServiceActions.ActionTypes.GetServiceToDeviceMap: {
            return {
                ...state,
                uuid: action.payload.uuid,
                callState: LoadingState.loading,
            };
        }

        case CHServiceActions.ActionTypes.UpdateServiceNameAndZoneSuccess: {
            return {
                ...state,
                result: {
                    ...state.result,
                    [action.payload.instanceId]: {
                        ...state.result[action.payload.instanceId],
                        zoneUids: action.payload.zoneUids,
                        name: action.payload.name,
                    },
                },
                uuid: action.payload.uuid,
                callState: LoadingState.loaded,
            };
        }

        case CHServiceActions.ActionTypes.GetServicesSuccess: {
            const services = action.result.result;
            const pendingDeletions = state.pendingDeletions;

            removePendingDeletion(pendingDeletions, services);

            return {
                ...state,
                result: services,
                uuid: action.result.uuid,
                callState: LoadingState.loaded,
                pendingDeletions,
            };
        }

        default: {
            return state;
        }
    }
};

export const chLiteServicereducer = (
    state: CHLiteServiceState = { uuid: null, result: null, callState: LoadingState.init },
    action: CHServiceActions.LiteActions = null
): CHLiteServiceState => {
    switch (action.type) {
        case CHServiceActions.ActionTypes.ClearLiteServiceState: {
            return {
                ...state,
                result: null,
                uuid: null,
                callState: LoadingState.init,
            };
        }

        case CHServiceActions.ActionTypes.GetLiteServices: {
            return {
                ...state,
                uuid: action.payload.uuid,
                callState: LoadingState.loading,
            };
        }

        case CHServiceActions.ActionTypes.GetLiteServicesSuccess: {
            return {
                ...state,
                result: action.result.result,
                uuid: action.result.uuid,
                callState: LoadingState.loaded,
            };
        }

        default: {
            return state;
        }
    }
};
